<template>
  <div>
    <div class="card">
      <CardItem
        class="card-item"
        :itemCard="itemCard"
        @click.native="cardClick(itemCard)"
      />
      <div class="dd-btn">
        <p v-if="isGift" class="num">{{ itemCard.amount }}</p>
        <el-stepper
          v-else
          class="cardStepper"
          v-model="itemCard.amount"
          @change="handleChange"
          :min="0"
          read-only
          :disabled="isClose"
          :max="
            maxNum >= itemCard.amount && disabled ? itemCard.amount : maxNum
          "
        ></el-stepper>
      </div>
    </div>
  </div>
</template>

<script>
import CardItem from './cardItem';

export default {
  components: {
    CardItem,
  },
  data() {
    return {};
  },
  props: {
    cartData: {
      type: Object,
      default: () => {},
    },
    itemCard: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
    maxNum: {
      type: Number,
      default: 15,
    },
  },
  computed: {
    isGift() {
      return this.itemCard && this.itemCard.mduType === 2;
    },
  },
  mounted() {
    document.getElementsByClassName('cardStepper');
  },
  methods: {
    handleChange(currentValue, oldValue) {
      let isAdd = +currentValue > +oldValue;
      this.$trackEvent({
        eventId: 'sailing_c_x_cart_minicart_add_item_ck',
        eventLabel: '点击迷你购物车菜品加减号',
        attrs: {
          shop_id: this.cartData?.shopId,
          cart_id: this.cartData?.cartId,
          item_id: this.itemCard?.itemId,
          item_name: this.itemCard?.itemName,
          copy_num: this.itemCard?.amount,
          item_price: this.itemCard?.specialPrice,
          subitem: this.itemCard?.headImg ? {
            ...this.itemCard,
            has_image: true,
          } : {
            ...this.itemCard,
            has_image: false,
          },
          button_type: isAdd ? 1 : 0,
        },
      });
      this.$emit('change', currentValue, this.itemCard, isAdd);
    },
    cardClick(item) {
      this.$emit('cardSku', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  .card-item {
    flex: 1;
  }
  .dd-btn {
    display: flex;
    align-items: flex-start;
    margin-left: 12px;
    width: 100px;
    .num {
      font-family: 'Aspira Light';
      font-size: 16px;
      width: 81px;
      text-align: center;
      position: relative;
      top: 2px;
      right: -18px;
    }
    .el-stepper {
      transform: scale(0.7, 0.7);
      margin-right: -16px;
    }
  }
}
@media screen and (max-width: 768px) {
  .card {
    min-width: rem(666);
    .dd-btn {
      margin-left: rem(24);
      .num {
        width: 81px;
        top: rem(4);
      }
      .el-stepper {
        transform: scale(0.7, 0.7);
        margin-right: rem(-32);
      }
    }
  }
}
</style>
<style lang="scss">
.card {
  // .el-stepper.is-disabled .el-stepper__decrease,
  // .el-stepper.is-disabled .el-stepper__increase {
  //   border-color: #ff7a45 !important;
  //   color: #ff7a45 !important;
  // }
  .el-input__inner {
    pointer-events: none;
    line-height: 20px;
  }
  .el-stepper {
    .el-input {
      width: 116px;
      input {
        color: #000 !important;
      }
      .el-input__inner {
        font-size: 22px;
        color: #000 !important;
        opacity: 1;
      }
    }
  }
}
</style>
